import { otherRouter} from './config'
// 所有上面定义的路由都要写在下面的routers里
export default  otherRouter
